/* stylelint-disable */
import styled from 'styled-components';
import Page from 'app/shared/containers/Page';

export const ListingLandingPage = styled(Page)`
    margin-top: -1px;
`;

export const CrossPromoPadding = styled.div`
    padding-bottom: 20px;
`;

export const HeroSubtextMaxWidth = styled.div`
    margin: 0 auto;
    max-width: 620px;
`;

export const PromoLogos = styled.div`
    padding-top: 25px;
    text-align: center;

    @media (min-width: 1280px) {
        text-align: left;
    }

    img {
        display: block;
        margin: 0 auto;
        padding-top: 16px;

        &:first-child {
            padding-top: 0;
        }

        @media (min-width: 576px) {
            display: inline-block;
            margin-right: 26px;
            padding-top: 0;

            &:last-child {
                margin-right: 0;
            }
        }
    }
`;

export const PaidListingMessage = styled.div`
    display: inline-block;
`;
